import { actFormCRUD } from "../../http";
import {
  ACT_FORM_ADD_ERROR,
  ACT_FORM_ADD_REQUEST,
  ACT_FORM_ADD_SUCCESS,
  ACT_FORM_DELETE_ERROR,
  ACT_FORM_DELETE_REQUEST,
  ACT_FORM_DELETE_SUCCESS,
  ACT_FORM_EDIT_ERROR,
  ACT_FORM_EDIT_REQUEST,
  ACT_FORM_EDIT_SUCCESS,
  ACT_FORM_GET_BY_KEY_ERROR,
  ACT_FORM_GET_BY_KEY_REQUEST,
  ACT_FORM_GET_BY_KEY_SUCCESS,
  ACT_FORM_GET_ERROR,
  ACT_FORM_GET_REQUEST,
  ACT_FORM_GET_SUCCESS,
} from "../constants/actFormConstants";

export const getActForms = (args) => async (dispatch) => {
  try {
    dispatch({
      type: ACT_FORM_GET_REQUEST,
    });

    const data = await actFormCRUD.search(args);
    dispatch({
      type: ACT_FORM_GET_SUCCESS,
      payload: data.result,
    });
    return data.result;
  } catch (error) {
    dispatch({
      type: ACT_FORM_GET_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addActForm = (data, args) => async (dispatch) => {
  try {
    dispatch({
      type: ACT_FORM_ADD_REQUEST,
    });

    const response = await actFormCRUD.create(data);
    await dispatch(getActForms(args));
    dispatch({
      type: ACT_FORM_ADD_SUCCESS,
    });

    return response.id;
  } catch (error) {
    dispatch({
      type: ACT_FORM_ADD_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const editActForm = (data, args) => async (dispatch) => {
  try {
    dispatch({
      type: ACT_FORM_EDIT_REQUEST,
    });

    await actFormCRUD.edit(data);
    await dispatch(getActForms(args));

    dispatch({
      type: ACT_FORM_EDIT_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: ACT_FORM_EDIT_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteActForm = (id, args) => async (dispatch) => {
  try {
    dispatch({
      type: ACT_FORM_DELETE_REQUEST,
    });

    await actFormCRUD.delete(id);
    await dispatch(getActForms(args));

    dispatch({
      type: ACT_FORM_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: ACT_FORM_DELETE_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
